import { InjectionToken } from '@angular/core';

export interface RuntimeConfig {
  production: boolean;
  apiBase: string;
  frontendUrl: string;
}

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>('runtime.config');
